import { Component, Inject,OnInit } from '@angular/core';
import {StatusBugComponent} from 'src/app/components/bug-module/status-bug/status-bug.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { S3ServiceService } from 'src/app/services/s3Service/s3-service.service';
import { observableToPromise } from 'src/app/services/ObservableToPromise';
import { DocumentsService } from 'src/app/services/documentsOperation/documents-service.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { ToastrService } from 'ngx-toastr';
import {BugModuleService} from 'src/app/services/bug-module/bug-module.service';

@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.scss']
})
export class ImageDialogComponent implements OnInit {
  issuePhoto: string[]=[];
  photos;
  photosbeforeparse=[];
  photosAvailable:boolean=true;
  documentDownloadUrls: string[] = [];
  documentViewUrls: any[] = [];
  urlFetchedAt: number;
  urlValidDurationMs: number = 5 * 60 * 1000; // 5 minutes
  inlineImageUrl;
  constructor(
    public dialogRef: MatDialogRef<StatusBugComponent>,
    public bugmoduleservice: BugModuleService,
    public s3Service:S3ServiceService,
    public documentService:DocumentsService,
    private sanitizer: DomSanitizer,
    private toast: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any) 
    { 
      this.issuePhoto=data;
    }

  ngOnInit(): void {
    this.getImages();
  }
  sanitizeBlobUrl(blobUrl: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }
  async getImages(): Promise<void> {
    const now = Date.now();

    // Optional: Clear previous URLs
    this.documentDownloadUrls = [];
    this.documentViewUrls = [];

    try {
      for (let i = 0; i < this.issuePhoto.length; i++) {
        const res: any = await observableToPromise(
          this.documentService.getDocumentById(this.issuePhoto[i])
        );

        const certificateCloudStoragePath = res.body.cloud_storage_path;

        const responsePreSignUrl: any = await observableToPromise(
          this.s3Service.getGetPresignedUrl(certificateCloudStoragePath)
        );

        const url = responsePreSignUrl.body.url;
        const response = await fetch(url);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);

        this.documentDownloadUrls.push(objectUrl);
        this.documentViewUrls.push(this.sanitizeBlobUrl(objectUrl));
      }

      this.urlFetchedAt = now;
    } catch (err) {
      console.error('Failed to load image or get presigned URL:', err);
      this.documentDownloadUrls = [];
      this.documentViewUrls = [];
    }
  }

  downloadAllImages(): void {
  this.documentDownloadUrls.forEach((url, index) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = `image-${index + 1}.jpg`;  // or use PNG/appropriate extension
    a.click();
  });
}

  closeDialog() {
    this.dialogRef.close();
  }
}
